export const getProvinceCode = zipCode => String(zipCode).substr(0, 2)

// eslint-disable-next-line
export const applyTax = (tax, price) => parseFloat(price) * (1 + parseFloat(tax) / 100)
